import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import Search from "./common/Search";
import Sidebar from "./common/Sidebar";
import StickyMenu from "./common/StickyMenu";
import MobileMenu from "./common/MobileMenu";
import { Styles } from "./styles/header.js";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

class Header extends Component {
  render() {
    return (
      <Styles>
        {/* Topbar */}
        <section className="top-bar">
          <Container>
            <Row>
              <Col lg="6" md="5">
                <div className="bar-left">
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <i className="las la-map-marker"></i>Law College, Nagpur,
                      400423
                    </li>
                    <li className="list-inline-item">
                      <Link to={process.env.PUBLIC_URL + "/faq"}>
                        Have Questions
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg="6" md="7">
                <div className="bar-right d-flex justify-content-end">
                  <ul className="list-unstyled list-inline bar-social">
                    <li className="list-inline-item">
                      <a href={process.env.PUBLIC_URL + "/"}>
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href={process.env.PUBLIC_URL + "/"}>
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href={process.env.PUBLIC_URL + "/"}>
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href={process.env.PUBLIC_URL + "/"}>
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                  <ul className="list-unstyled list-inline bar-lang">
                    <li className="list-inline-item">
                      <Dropdown>
                        <Dropdown.Toggle as="a">
                          <img
                            src={
                              process.env.PUBLIC_URL + "/assets/images/ind.png"
                            }
                            alt=""
                          />
                          English<i className="las la-angle-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu as="ul">
                          <Dropdown.Item as="li">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/ind.png"
                              }
                              alt=""
                            />{" "}
                            English
                          </Dropdown.Item>
                          <Dropdown.Item as="li">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/fra.png"
                              }
                              alt=""
                            />{" "}
                            French
                          </Dropdown.Item>
                          <Dropdown.Item as="li">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/ger.png"
                              }
                              alt=""
                            />{" "}
                            German
                          </Dropdown.Item>
                          <Dropdown.Item as="li">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/spa.png"
                              }
                              alt=""
                            />{" "}
                            Spanish
                          </Dropdown.Item>
                          <Dropdown.Item as="li">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/bra.png"
                              }
                              alt=""
                            />{" "}
                            Brazilian
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                  <ul className="list-unstyled list-inline bar-login">
                    <li className="list-inline-item">
                      <Link to={process.env.PUBLIC_URL + "/login"}>
                        <i className="las la-user"></i>Log In
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to={process.env.PUBLIC_URL + "/registration"}>
                        <i className="las la-user-edit"></i>Register
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Logo Area */}
        <section className="logo-area">
          <Container>
            <Row>
              <Col md="3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="logo">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip1">
                          Shri C. P. Radhakrishnan
                        </Tooltip>
                      }
                    >
                      <Link to={process.env.PUBLIC_URL + "/"}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/Shri_C_P_ Radhakrishnan.jpg"
                          }
                          alt="Shri C. P. Radhakrishnan"
                        />
                      </Link>
                    </OverlayTrigger>
                  </div>

                  <div className="logo">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip2">Devendra Fadanvis</Tooltip>
                      }
                    >
                      <Link to={process.env.PUBLIC_URL + "/"}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/Devendra_Fadanvis.png"
                          }
                          alt="Devendra Fadanvis"
                        />
                      </Link>
                    </OverlayTrigger>
                  </div>

                  <div className="logo">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip3">Eknath Shinde</Tooltip>}
                    >
                      <Link to={process.env.PUBLIC_URL + "/"}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/Eknath_Shinde.png"
                          }
                          alt="Eknath Shinde"
                        />
                      </Link>
                    </OverlayTrigger>
                  </div>

                  <div className="logo">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip4">Ajit Pawar</Tooltip>}
                    >
                      <Link to={process.env.PUBLIC_URL + "/"}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/ajit_pawar.png"
                          }
                          alt="Ajit Pawar"
                        />
                      </Link>
                    </OverlayTrigger>
                  </div>
                  
                </div>
              </Col>

              <Col md="9">
                <div className="logo-contact-box d-flex justify-content-end">
                  <div className="emcontact-box d-flex">
                    <div className="box-icon">
                      <i className="flaticon-phone-call"></i>
                    </div>
                    <div className="box-content">
                      <p>Call Us Now</p>
                      <span>+91 9022547856</span>
                    </div>
                  </div>
                  <div className="emcontact-box d-flex">
                    <div className="box-icon">
                      <i className="flaticon-envelope"></i>
                    </div>
                    <div className="box-content">
                      <p>Enquery Us</p>
                      <span>lawcollege@gmail.com</span>
                    </div>
                  </div>
                  <div className="apply-btn">
                    <Link to={process.env.PUBLIC_URL + "/registration"}>
                      <i className="las la-clipboard-list"></i>Apply Now
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Navbar */}
        <section className="main-menu">
          <Container>
            <Row>
              <Col md="12">
                <div className="main-menu-box">
                  <div className="menu-box d-flex justify-content-between">
                    <ul className="nav menu-nav">
                      <li className="nav-item dropdown active">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Home <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item active">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/"}
                            >
                              Home Style 1
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/home-two"}
                            >
                              Home Style 2
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Chancellor <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/chancellor"}
                            >
                              About Chancellor of Public Universities of
                              Maharashtra
                            </Link>
                          </li>
                        </ul>
                      </li>

                      {/* Pages with Nested Dropdown */}
                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Education <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item dropdown-submenu">
                            <Link
                              className="nav-link dropdown-toggle"
                              to={process.env.PUBLIC_URL + "/education"}
                              data-toggle="dropdown"
                            >
                              Law Education{" "}
                              <i className="las la-angle-right"></i>
                            </Link>
                            <ul className="dropdown-submenu-list list-unstyled">
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={process.env.PUBLIC_URL + "/education/cet"}
                                >
                                  CET
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={process.env.PUBLIC_URL + "/education/nri"}
                                >
                                  NRI
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item dropdown-submenu">
                            <Link
                              className="nav-link dropdown-toggle"
                              to={process.env.PUBLIC_URL + "/college"}
                              data-toggle="dropdown"
                            >
                              Law Colleges{" "}
                              <i className="las la-angle-right"></i>
                            </Link>
                            <ul className="dropdown-submenu-list list-unstyled">
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/college/mumbai"
                                  }
                                >
                                  Mumbai Law Colleges
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={process.env.PUBLIC_URL + "/college/pune"}
                                >
                                  Pune Law Colleges
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/college/nagpur"
                                  }
                                >
                                  Nagpur Law Colleges
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/college/nashik"
                                  }
                                >
                                  Nashik Law Colleges
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL +
                                    "/college/aurangabad"
                                  }
                                >
                                  Aurangabad Law Colleges
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/about"}
                            >
                              About Us
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/contact"}
                            >
                              Contact Us
                            </Link>
                          </li>
                        </ul>
                      </li>

                      {/* Courses with Nested Dropdown */}
                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Courses <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item dropdown-submenu">
                            <Link
                              className="nav-link dropdown-toggle"
                              to={process.env.PUBLIC_URL + "/course-grid"}
                              data-toggle="dropdown"
                            >
                              Law Programs{" "}
                              <i className="las la-angle-right"></i>
                            </Link>
                            <ul className="dropdown-submenu-list list-unstyled">
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/courses/ba-llb"
                                  }
                                >
                                  BA LLB (5 Years)
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/courses/bba-llb"
                                  }
                                >
                                  BBA LLB (5 Years)
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL + "/courses/bcom-llb"
                                  }
                                >
                                  B.Com LLB (5 Years)
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={process.env.PUBLIC_URL + "/courses/llb"}
                                >
                                  LLB (3 Years)
                                </Link>
                              </li>
                            </ul>
                          </li>
                          {/* <li className="nav-item dropdown-submenu">
                            <Link
                              className="nav-link dropdown-toggle"
                              to={process.env.PUBLIC_URL + "/course-list"}
                              data-toggle="dropdown"
                            >
                              Course Materials{" "}
                              <i className="las la-angle-right"></i>
                            </Link>
                            <ul className="dropdown-submenu-list list-unstyled">
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={process.env.PUBLIC_URL + "/courses/llm"}
                                >
                                  NOTES BY RENOWNED LECTURERS
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to={
                                    process.env.PUBLIC_URL +
                                    "/courses/llm-criminal"
                                  }
                                >
                                  READING MATERIALS
                                </Link>
                              </li>
                            </ul>
                          </li> */}
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Course Materials <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/lecture"}
                            >
                              NOTES BY RENOWNED LECTURERS 
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/reading"}
                            >
                              READING MATERIALS
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Event <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/events"}
                            >
                              Events
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/event-details"}
                            >
                              Event Details
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Blog <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/blog-classic"}
                            >
                              Blog Classic
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/blog-grid"}
                            >
                              Blog Grid
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/blog-details"}
                            >
                              Blog Details
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/"}
                          data-toggle="dropdown"
                        >
                          Videos <i className="las la-angle-down"></i>
                        </Link>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/video"}
                            >
                              Videos
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>

                    <ul className="nav search-cart-bar">
                      <li className="nav-item search-box">
                        <Search />
                      </li>
                      <li className="nav-item cart-box">
                        <Link
                          to={process.env.PUBLIC_URL + "/cart"}
                          className="nav-link nav-cart"
                        >
                          <i className="las la-shopping-bag"></i>
                        </Link>
                      </li>
                      <li className="nav-item side-box">
                        <Sidebar />
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Sticky Menu */}
        <StickyMenu />

        {/* Mobile Menu */}
        <MobileMenu />
      </Styles>
    );
  }
}

export default Header;
